import AccountDropdownMenuContainer from "~/Account/AccountDropdownMenuContainer"

export default AccountDropdownMenuContainer
